import { IProgram } from '../../../../domain/core/entities/programEntity';
import IProgramFailure from '../../../../domain/core/failures/program/programFailure';
import ProgramUseCase from '../../../../domain/useCases/program/programUseCase';
import React, { Dispatch } from 'react';

export interface IProgramsListActions {
  getPrograms: Function;
  getProgramsByQuery: Function;
  deleteProgram: Function;
  editProgramStatus: Function;
}

const getPrograms = (obj: { start?: string; isNext?: string; isPrevious?: string; limit?: number; }) => async (dispatch: Dispatch<any>) => {
    dispatch({ type: 'GET_PROGRAMS_LOADING' });

    await new ProgramUseCase()
      .getPrograms({start: obj.start, isNext: obj.isNext, isPrevious: obj.isPrevious, limit: obj.limit })
      .then((res: IProgram[]) => {
        dispatch({
          type: 'GET_PROGRAMS_SUCESSFUL',
          payload: { data: res, sucessful: true },
        });
      })
      .catch((error: IProgramFailure) => {
        dispatch({ type: 'GET_PROGRAMS_ERROR', payload: { error: error } });
      });
  };

  const getProgramsByQuery = (obj: { start?: string; isNext?: string; isPrevious?: string; limit?: number; searchQuery: string }) => async (dispatch: Dispatch<any>) => {
    dispatch({ type: 'GET_PROGRAMS_LOADING' });

    await new ProgramUseCase()
      .getProgramsByQuery({start: obj.start, isNext: obj.isNext, isPrevious: obj.isPrevious, limit: obj.limit, searchQuery: obj.searchQuery })
      .then((res: IProgram[]) => {
        dispatch({
          type: 'GET_PROGRAMS_SUCESSFUL',
          payload: { data: res, sucessful: true },
        });
      })
      .catch((error: IProgramFailure) => {
        dispatch({ type: 'GET_PROGRAMS_ERROR', payload: { error: error } });
      });
  };

  const deleteProgram = (programId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({ type: 'DELETE_PROGRAM_LOADING' });

    await new ProgramUseCase()
      .deleteProgram(programId)
      .then((res: string) => {
        dispatch({
          type: 'DELETE_PROGRAM_SUCESSFUL',
          payload: { data: res, sucessful: true },
        });
      })
      .catch((error: IProgramFailure) => {
        dispatch({ type: 'DELETE_PROGRAM_ERROR', payload: { error: error } });
      });
  };

const editProgramStatus = (programId: string, status: string) => async (dispatch: Dispatch<any>) => {
    dispatch({ type: 'EDIT_PROGRAM_STATUS_LOADING' });

    await new ProgramUseCase()
      .editProgramStatus(programId, status)
      .then((res: string) => {
        dispatch({
          type: 'EDIT_PROGRAM_STATUS_SUCESSFUL',
          payload: { data: res, sucessful: true },
        });
      })
      .catch((error: IProgramFailure) => {
        dispatch({ type: 'EDIT_PROGRAM_STATUS_ERROR', payload: { error: error } });
      });
  };

export const actions = {
  getPrograms,
  getProgramsByQuery,
  deleteProgram,
  editProgramStatus
};
